import { render, staticRenderFns } from "./notice-modal.vue?vue&type=template&id=7b71bb4c&"
import script from "./notice-modal.vue?vue&type=script&lang=js&"
export * from "./notice-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports